<template>
  <div
    class="letters-builder-settings-form__wrapper"
    :class="{ [extraClass]: !!extraClass }"
  >
    <div class="letters-builder-settings__header">Settings</div>

    <div class="container top">
      <div class="options pages">
        <span class="header">Pages</span>
        <VForm
          :name="name"
          :fields="formData.fieldsPages"
          :initialValues="initialValues"
          @change="val => $emit('change', val)"
        ></VForm>
      </div>
      <div class="options colors">
        <span class="header">Color</span>
        <VForm
          :name="name"
          :fields="formData.fieldsColor"
          :initialValues="initialValues"
          @change="val => $emit('change', val)"
        ></VForm>
      </div>
    </div>

    <div class="container middle">
      <div class="options postage">
        <span class="header">Postage Options</span>
        <VForm
          :name="name"
          :fields="formData.fieldsPostageOptions"
          :initialValues="initialValues"
          @change="val => $emit('change', val)"
        ></VForm>
      </div>
      <div class="options additional">
        <span class="header">Additional Options</span>
        <VWarning
          v-if="showWarning"
          :message="message"
          :illustration="illustration"
          :timeout="3500"
          @change="showWarning = false"
        ></VWarning>
        <VForm
          :name="name"
          :fields="formData.fieldsAdditionalOptions"
          :initialValues="initialValues"
          @change="val => onAdditionalOptionsChange(val)"
        ></VForm>
        <!-- <div -->
        <!--   class="perforation&#45;wrapper" -->
        <!--   :class="{ ['disabled']: !use_perforated }" -->
        <!-- > -->
        <!--   <VForm -->
        <!--     :name="name" -->
        <!--     :fields="formData.fieldsPerforation" -->
        <!--     :initialValues="initialValues" -->
        <!--     @change="val => $emit('change', val)" -->
        <!--   ></VForm> -->
        <!-- </div> -->
      </div>
    </div>

    <!--<div class="container bottom">-->
    <!--<div class="options extra-postage">-->
    <!--<div class="header" @click="onExtraPostageClick">-->
    <!--<span>Extra Postage Options</span>-->
    <!--<i :class="getIconClass(isOpenExtraPostageOptions)"></i>-->
    <!--</div>-->
    <!--<VForm-->
    <!--v-show="isOpenExtraPostageOptions"-->
    <!--:name="name"-->
    <!--:fields="formData.fieldsExtraPostageOptions"-->
    <!--:initialValues="initialValues"-->
    <!--&gt;</VForm>-->
    <!--</div>-->
    <!--</div>-->

    <div v-if="productCodesList.length" class="container bottom">
      <div class="options product-code">
        <div class="header" @click="onExtraPostageClick">
          <span>Advanced</span>
          <i :class="getIconClass(isOpenExtraPostageOptions)"></i>
        </div>
        <VForm
          v-show="isOpenExtraPostageOptions"
          :name="name"
          :fields="formData.productCode"
          :initialValues="initialValues"
          @change="val => $emit('change', val)"
        ></VForm>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import { mapActions, mapGetters } from "vuex";
import cloneDeep from "lodash/cloneDeep";
// components
import VForm from "@/components/VForm";
import VButton from "@/components/VButton";
import VRangeIntInput from "@/components/VRangeIntInput";
import VWarning from "@/components/VWarning";
import withFormUtils from "@/mixins/withForm";
import withToasted from "@/mixins/withToasted";
import letterPreview from "@/assets/images/letter-preview.svg";
import {
  COLOR_OPTIONS,
  POSTAGE_OPTIONS,
  EXTRA_POSTAGE_OPTIONS,
  PAGES_OPTIONS
} from "@/constants/forms";
export default Vue.component("LettersBuilderSettingsForm", {
  props: {
    initialValues: VueTypes.object,
    extraClass: VueTypes.string.def("")
  },

  components: { VForm, VButton, VRangeIntInput, VWarning },

  mixins: [withFormUtils, withToasted],

  data() {
    return {
      //for chevrons
      isOpenExtraPostageOptions: false,
      name: "lettersBuilder",
      //for rangeInt
      use_perforated: false,
      //for warning
      showWarning: false,
      message:
        "Address area may overflow main text without inserting the blank page",
      illustration: letterPreview,
      //for Return Envelope checkbox
      isReturnEnvelope: this.initialValues.return_envelope,
      extraOptionsClass: ""
    };
  },
  methods: {
    onExtraPostageClick() {
      this.isOpenExtraPostageOptions = !this.isOpenExtraPostageOptions;
    },

    getIconClass(optionsBlock) {
      let base = "far fa-chevron-";
      if (!optionsBlock) {
        base = `${base}${this.position === "down" ? "up" : "down"}`;
      } else {
        base = `${base}${this.position === "down" ? "down" : "up"}`;
      }
      return base;
    },

    onAdditionalOptionsChange(checkbox) {
      if (checkbox.name === "return_envelope" && checkbox.value === true) {
        this.use_perforated = true;
        this.updateValue({
          formName: this.name,
          fieldName: "use_perforated",
          value: true
        });
      }
      this.$emit("change", checkbox);
    },

    ...mapActions("lettersTemplates", ["updateLettersTemplate", "fetchProductCodesList"])
  },
  computed: {
    formData() {
      return {
        productCode: [
          {
            name: "product_code_id",
            label: "Unique Product Code (optional)",
            classType: "primary",
            selectItems: this.productCodesList,
            placeholder: "Choose template",
            elementType: "vue-select",
            extraClassRoot: "template-wrapper"
          }
        ],
        fieldsPages: [
          {
            name: "page_options",
            selectItems: PAGES_OPTIONS,
            elementType: "radioGroup"
          }
        ],
        fieldsColor: [
          {
            name: "color",
            selectItems: COLOR_OPTIONS,
            elementType: "radioGroup"
          }
        ],
        fieldsAdditionalOptions: [
          {
            name: "blank_page",
            label: "Insert Blank Page First",
            elementType: "checkbox",
            extraClass: "additional-options-checkbox"
          }
          // {
          //   name: "return_envelope",
          //   label: "Return Envelope",
          //   elementType: "checkbox",
          //   connectedWith: this.isReturnEnvelope ? "use_perforated" : "",
          //   extraClass: "additional-options-checkbox",
          //   innerChildProps: {
          //     hint: {
          //       text: "Return envelope can be used only with perforation"
          //     }
          //   }
          // },
          // {
          //   name: "use_perforated",
          //   label: "Perforation",
          //   elementType: "checkbox",
          //   extraClass: "additional-options-checkbox"
          // }
        ],

        fieldsPostageOptions: [
          {
            name: "mail_type",
            selectItems: POSTAGE_OPTIONS,
            elementType: "radioGroup"
          }
        ],

        fieldsExtraPostageOptions: [
          {
            name: "additional_service",
            selectItems: cloneDeep(EXTRA_POSTAGE_OPTIONS).map(item => {
              item.extraClass = `${
                item.extraClass ? item.extraClass : ""
              } additional-options-radio`;
              return item;
            }),
            elementType: "radioGroup",
            extraClass: this.extraOptionsClass
          }
        ],
        fieldsPerforation: [
          {
            name: "perforated",
            elementType: "rangeInt",
            firstFixed: true
          }
        ]
      };
    },

    _getInsertBankCheckboxValue() {
      const {
        name: insertBankCheckboxName
      } = this.formData.fieldsAdditionalOptions[0];
      return this.getValue(insertBankCheckboxName);
    },
    // _getPerforationCheckboxValue() {
    //   const {
    //     name: perforationCheckBoxName
    //   } = this.formData.fieldsAdditionalOptions[2];
    //   return this.getValue(perforationCheckBoxName);
    // },
    // _getReturnEnvelopeValue() {
    //   const {
    //     name: returnEnvelopeName
    //   } = this.formData.fieldsAdditionalOptions[1];
    //
    //   return this.getValue(returnEnvelopeName);
    // },

    _getPostageOptionsValue() {
      const {
        name: postageOptionsName
      } = this.formData.fieldsPostageOptions[0];
      return this.getValue(postageOptionsName);
    },

    _isFormsTouched() {
      return this.isFormTouched("lettersBuilder");
    },

    ...mapGetters("lettersTemplates", ["isLoading", "productCodesList"])
  },

  watch: {
    // initialValues(val) {
    //   if (this.initialValues) {
    //     this.initializeForm({
    //       formName: this.name,
    //       fields: {
    //         ...this.initialValues,
    //         perforated: this.initialValues.use_perforated && {
    //           first: 1,
    //           last: this.initialValues.perforated
    //         },
    //         use_perforated: !!this.initialValues.perforated
    //       }
    //     });
    //   }
    // },
    _getInsertBankCheckboxValue() {
      this.showWarning = !this._getInsertBankCheckboxValue;
    },
    _getPerforationCheckboxValue() {
      this.use_perforated = this._getPerforationCheckboxValue;
      this.returnEnvelope = this._getReturnEnvelopeValue;
      if (!this.use_perforated && this.returnEnvelope) {
        this.updateValue({
          formName: this.name,
          fieldName: "return_envelope",
          value: false
        });
      }
      if (!this.use_perforated) {
        this.updateValue({
          formName: this.name,
          fieldName: "perforated",
          value: {
            first: 1,
            last: null
          }
        });
      }
    },

    _getPostageOptionsValue(val) {
      if (val === "usps_standard") {
        //Need to refactor code to implement this toster
        /*  if (this.isFieldTouched("mail_type")) {
          this.warningToast(
            "Extra Postage Options has been reset due to USPS Standard mail type"
          );
        }*/
        this.extraOptionsClass = "disabled";
        this.updateValue({
          formName: this.name,
          fieldName: "additional_service",
          value: null
        });
      } else {
        this.extraOptionsClass = "";
        this.updateValue({
          formName: this.name,
          fieldName: "additional_service",
          value: this.initialValues.additional_service
        });
      }
    }
  },

  mounted() {
    this.fetchProductCodesList()
  }
});
</script>

<style lang="scss" scoped>
$ns: "letters-builder-settings";
.#{$ns}__header {
  font-family: Lato-Regular, Arial, sans-serif;
  font-size: 22px;
  line-height: 1.2;
  margin-bottom: 30px;
}
.container {
  display: flex;
  &.top {
    margin-bottom: 60px;
  }

  &.middle {
    margin-bottom: 60px;
  }

  &.bottom {
  }
}
.header {
  display: flex;
  font-family: Lato-Bold, Arial, sans-serif;
  font-size: 16px;
  color: $title-text-color;
  margin-bottom: 30px;
}
.options {
  width: 195px;

  &.pages,
  &.additional {
    position: relative;
    margin-right: 18px;
    width: 190px;
  }

  &.postage {
    z-index: 0;
  }

  &.extra-postage {
    .header {
      cursor: pointer;
      span {
        display: inline-block;
        margin-right: 20px;
        white-space: nowrap;
      }
    }
  }

  &.product-code {
    width: 100%;

    .header {
      cursor: pointer;
      span {
        display: inline-block;
        margin-right: 20px;
        white-space: nowrap;
      }
    }
  }
}
.perforation-wrapper {
  height: 32px;

  &.disabled {
    pointer-events: none;
    color: $tertiary-grey;
    /deep/ input {
      color: $tertiary-grey;
    }
  }
}

/deep/ .additional .field-wrapper {
  margin-bottom: 32px;
}

/deep/ .wide label {
  width: 160px;
}
/*/deep/ .additional-options-radio.checked {*/
/*  z-index: 9999;*/
/*}*/

/deep/ .v-radio-input-element {
  width: fit-content;
  label {
    font-family: Lato-Regular, Arial, Helvetica, "sans-serif";
  }
}

/*for warning*/
/deep/ .v-warning__wrapper {
  top: 40px;
  right: 195px;
}
/*for radio block*/
/deep/ .v-radio-input__wrapper:hover {
  .check {
    border: 1px solid $primary-color;
  }

  label {
    color: $main-text-color;
    font-family: Lato-Regular, Arial, Helvetica, "sans-serif";
  }
}
</style>

<style lang="scss">
.v-radio-input-group__wrapper.disabled {
  pointer-events: none;
}
</style>
